import TUploadHead from './upload-head.vue'

TUploadHead.install = Vue => {
  Vue.component(TUploadHead.name, TUploadHead)
}

export default TUploadHead



// WEBPACK FOOTER //
// ./src/module/upload-head/index.js